import { createStyles } from '@material-ui/styles';

export default () =>
  createStyles({
    reasonField: {
      '& .MuiOutlinedInput-root': { height: 'auto' },
      '& .MuiOutlinedInput-multiline': { padding: 14 },
    },
    buttonsBypassActions: { margin: '8px 0px' },
  });
